import castArray from 'lodash/fp/castArray';
import flow from 'lodash/fp/flow';
import filter from 'lodash/fp/filter';
import get from 'lodash/fp/get';
import getOr from 'lodash/fp/getOr';
import map from 'lodash/fp/map';

export default function getRecoFlags({ productId, booking, recoCookie, isEnhancement }) {
	if (isEnhancement) {
		let enhancement_sku = [];
		let reco_enhancement_sku = [];
		let enhancement_datalake_reco_id = [];
		let enhancement_reco_flag = [];
		let reco_enhancement_property_name = [];
		let reco_enhancement_name = [];
		const eventProducts = getOr([], ['eventProducts'])(booking);

		// DEV NOTE: If given productId as argument, only return enhancement information for that productId,
		// otherwise function will return information for all enhancements in booking.
		let productIdsArray = productId
			? castArray(Number(productId))
			: map(get('productId'))(eventProducts);

		flow(
			filter(eventProduct => productIdsArray.includes(eventProduct.productId)),
			map(eventProduct => {
				const { price, code, name } = eventProduct;

				flow(
					get(['ticketBreakdown', 'ticketTypes']),
					map(() => {
						const recoItem =
							recoCookie?.datalakeRecoIds?.find(
								x => x?.sku?.toLowerCase() === code.toLowerCase()
							) ?? null;
						const isReco = !!recoItem;
						const datalakeId = isReco ? (recoItem.datalakeRecoId ?? 'na') : 'na';
						if (code) {
							enhancement_sku.push(code);
							reco_enhancement_sku.push(isReco ? code : 'na');
						}
						reco_enhancement_name.push(isReco ? name : 'na');
						reco_enhancement_property_name.push(isReco ? recoItem.ors : 'na');
						enhancement_reco_flag.push(isReco ? 'yes' : 'no');
						enhancement_datalake_reco_id.push(isReco ? datalakeId : 'na');
					})
				)(price);
			})
		)(eventProducts);

		return {
			enhancement_sku,
			reco_enhancement_property_name,
			reco_enhancement_sku,
			reco_enhancement_name,
			enhancement_reco_flag,
			enhancement_datalake_reco_id,
		};
	} else {
		let property_datalake_reco_id = [];
		let property_reco_flag = [];
		let reco_property_name = [];
		let reco_property_code = [];

		return flow(
			get(['hotelProducts']),
			map(hotelProduct => {
				const orsCode = get(['orsHotelCode'])(hotelProduct);
				const recoItem =
					recoCookie?.datalakeRecoIds?.find(
						x => x?.ors?.toLowerCase() === orsCode.toLowerCase() && x.type === 'property'
					) ?? null;
				const isReco = !!recoItem;
				const datalakeId = isReco ? (recoItem.datalakeRecoId ?? 'na') : 'na';
				property_reco_flag.push(isReco ? 'yes' : 'no');
				reco_property_code.push(isReco ? recoItem.ors : 'na');
				reco_property_name.push(isReco ? recoItem.ors : 'na');
				property_datalake_reco_id.push(isReco ? datalakeId : 'na');
			}),
			() => ({
				property_reco_flag,
				reco_property_name,
				reco_property_code,
				property_datalake_reco_id,
			})
		)(booking);
	}
}
